import { Amplify } from 'aws-amplify'
import {
  signIn as amplifySignIn,
  signOut as amplifySignOut,
  getCurrentUser,
  fetchAuthSession,
  fetchUserAttributes,
  confirmSignIn as amplifyConfirmSignIn,
} from 'aws-amplify/auth'

console.log(`process.env.APP_ENV:${process.env.REACT_APP_ENV}`)

const authConfig = process.env.REACT_APP_ENV === 'production' ? {
  userPoolId: 'ap-northeast-1_sA5AVYbrp',
  userPoolClientId: '569pup3b0n3tdasfaq1qiu7ju5',
} : {
  userPoolId: 'ap-northeast-1_dRjET9hVi',
  userPoolClientId: '6bjdqmob939qqng35tvpduqore',
}

// AWS Account: Alleeks cosmebi-dev (223588641751)
// UserPool: COSMEbiUserPool
Amplify.configure({
  Auth: {
    Cognito: {
      ...authConfig,
    },
  },
})

export type AuthUserSession = {
  userId: string
  username: string
  attributes?: {
    email: string
    sub: string
  }
  needsNewPassword?: boolean
}

/** @deprecated Amplify v6 では CognitoUser を使わない。互換のため別名を残す */
export type CognitoUserWithChallenge = AuthUserSession

type SignInError = 'INCORRECT_PASSWORD'
type CompleteNewPasswordError = 'INVALID_PASSWORD'

export const getIdToken = async (): Promise<string | undefined> => {
  const session = await fetchAuthSession()
  return session.tokens?.idToken?.toString()
}

export const currentUserPoolUser = async (): Promise<AuthUserSession | null> => {
  try {
    const user = await getCurrentUser()
    let attributes: AuthUserSession['attributes']
    try {
      const attrs = await fetchUserAttributes()
      attributes = {
        email: attrs.email ?? '',
        sub: attrs.sub ?? user.userId,
      }
    } catch {
      // 属性取得に失敗してもログイン状態は有効
    }
    return {
      userId: user.userId,
      username: user.username,
      attributes,
    }
  } catch {
    return null
  }
}

export const signIn = async (
  username: string,
  password: string,
): Promise<AuthUserSession | SignInError> => {
  try {
    const { isSignedIn, nextStep } = await amplifySignIn({ username, password })

    if (nextStep.signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
      return {
        userId: '',
        username,
        needsNewPassword: true,
      }
    }

    if (isSignedIn || nextStep.signInStep === 'DONE') {
      const current = await currentUserPoolUser()
      return current ?? { userId: '', username }
    }

    return 'INCORRECT_PASSWORD'
  } catch {
    return 'INCORRECT_PASSWORD'
  }
}

export const completeNewPassword = async (
  password: string,
): Promise<AuthUserSession | CompleteNewPasswordError> => {
  try {
    await amplifyConfirmSignIn({ challengeResponse: password })
    const current = await currentUserPoolUser()
    return current ?? { userId: '', username: '' }
  } catch (e: any) {
    if (e?.name === 'InvalidPasswordException' || e?.name === 'InvalidParameterException') {
      return 'INVALID_PASSWORD'
    }
    throw e
  }
}

export const confirmSignInWithSmsMfa = (code: string) => {
  return amplifyConfirmSignIn({ challengeResponse: code })
}

export const signOut = async (): Promise<void> => {
  await amplifySignOut()
}
